<template>
  <el-table
    border
    :data="flatTableData"
    tooltip-effect="dark"
    style="width: 100%"
    @selection-change="setPaymentListSelected"
    :span-method="objectSpanMethod"
  >
    <el-table-column type="selection" width="55" property="applyId" />

    <el-table-column align="center" label="单据名称" property="applyTitle">
      <template slot-scope="scope">
        <el-link type="primary" @click="toPaymentDetailsPage(scope.row)">{{
          scope.row.applyTitle
        }}</el-link>
      </template>
    </el-table-column>

    <el-table-column
      v-for="item in paymentColumns"
      :key="item.key"
      :align="item.align"
      :prop="item.key"
      :label="item.title"
    />

    <el-table-column align="center" label="支付状态">
      <template slot-scope="scope">
        <Strong>
          <flow-status
            :size="7"
            :color="getPaymentStatusColor(scope.row.paymentStatusEnumItemCode)"
          />
          {{ getPaymentStatusText(scope.row.paymentStatusEnumItemCode) }}
        </Strong>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import rowspan from "@/view/mixins/rowspan";
import FlowStatus from "@/components/FlowStatus/FlowStatus";

import Vuex from "vuex";
import {
  paymentColumns,
  getMergeLinesByPaymentMode,
  getPaymentSelectedAttr,
  paymentStatusColors,
} from "../constant";
export default {
  components: {
    FlowStatus,
  },

  mixins: [rowspan],

  props: {
    tableData: {
      type: Array,
      required: true,
      default: (_) => [],
    },

    activityPaymentStatus: {
      type: Object,
      required: true,
    },

    paymentMode: {
      type: Object,
      required: true,
    },

    paymentStatusList: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      paymentColumns: paymentColumns,
      paymentListSelected: [],
    };
  },

  computed: {
    mergeLines() {
      return getMergeLinesByPaymentMode(this.paymentMode.itemCode);
    },

    flatTableData() {
      let flatTableData = [];
      this.tableData.forEach((tableItem) => {
        (tableItem.payments || []).forEach((payment) =>
          flatTableData.push(payment)
        );
      });
      return flatTableData;
    },

    paymentSelectedAttr() {
      return getPaymentSelectedAttr(this.paymentMode.itemCode);
    },

    paymentListSelectedIds() {
      const paymentListSelectedIds = this.paymentListSelected.map(
        (item) => item[this.paymentSelectedAttr]
      );
      return [...new Set(paymentListSelectedIds)];
    },
  },

  watch: {
    activityPaymentStatus: {
      handler(newValue) {
        this.setPaymentStatus(newValue.itemCode);
      },
    },

    paymentListSelectedIds: {
      deep: true,
      handler(newValue) {
        this.setSelectedIds(newValue);
        this.setSelectedDetails(this.paymentListSelected);
      },
    },

    "paymentMode.itemCode": {
      handler(newValue) {
        this.setPaymentMode(newValue);
      },
    },
  },

  methods: {
    ...Vuex.mapMutations({
      setPaymentStatus: "payment/SET_STATUS",
      setSelectedIds: "payment/SET_SELECTED_IDS",
      setSelectedDetails: "payment/SET_SELECTED_DETAILS",
      setPaymentMode: "payment/SET_PAYMENTMODE",
    }),

    setPaymentListSelected(selectedList) {
      if (this.paymentMode.itemCode !== "confirmByApply") {
        this.paymentListSelected = this.$lodash.cloneDeep(selectedList);
        return;
      }

      let paymentList = [];
      selectedList.forEach((selected) => {
        const filterList = this.flatTableData.filter(
          (item) => item.applyId === selected.applyId
        );
        paymentList.push(...filterList);
      });
      this.paymentListSelected = paymentList;
    },

    toPaymentDetailsPage(row) {
      this.$router.push({
        name: "paymentDetail",
        params: {
          applyListId: row.id,
          applyId: row.applyId,
          paymentStatusEnumItemCode: this.activityPaymentStatus.itemCode,
          paymentStatusEnumItemName: this.activityPaymentStatus.itemName,
        },
      });
    },

    getPaymentStatusColor(code) {
      const paymentConfig = paymentStatusColors.find(
        (item) => item.code === code
      );
      return paymentConfig && paymentConfig.color;
    },

    getPaymentStatusText(code) {
      const paymentStatus = this.paymentStatusList.find(
        (item) => item.itemCode === code
      );
      return paymentStatus && paymentStatus.itemName;
    },
  },
};
</script>
